/**
 * Route guard for Demo Video Studio — admin, super_admin, or marketing.
 * Requires REACT_APP_ENABLE_DEMO_STUDIO=true at build time.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { canAccessDemoStudio, isDemoStudioEnabled } from '../utils/demoStudioAccess';

const DemoStudioRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (!isDemoStudioEnabled()) {
    return <Navigate to="/" replace />;
  }

  if (loading) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}
        data-testid="demo-studio-loading-spinner"
      >
        <CircularProgress size={48} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessDemoStudio(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default DemoStudioRoute;
